<template>
  <div
    @contextmenu="selectComponentDEV($event, schema.model)"
    :class="[getSelectedDEV && 'dev-selected-component']"
    :key="generateId(idDynamic)"
  >
    <div class="d-flex" v-if="schema.attributesTextField.mask">
      <i4pro-icon-popover
        v-if="schema.attributesInfo"
        :class="[schema.attributesInfo.right ? 'ml-1 order-2' : 'mr-1']"
        :schema="schema"
        :model="model"
      />

      <v-text-field
        :rules="rules"
        :name="idDynamic"
        :id="generateId(idDynamic)"
        v-bind="schema.attributesTextField"
        :disabled="schema.readonly"
        v-model="value"
        :ref="schema.model"
        @blur="onBlur"
        @click:clear="clear"
        @change="onChange"
        @focus="onFocus"
        @input="onInput"
        v-mask="JSON.parse(JSON.stringify(schema.attributesTextField.mask))"
        :has-conditions="schema.hasConditions"
      >
        <template v-slot:label>
          {{ schema.attributesTextField.label }}
          <span v-if="schema.rules.includes('required')" class="red--text">*</span>
        </template>
      </v-text-field>
    </div>

    <div class="d-flex" v-else>
      <i4pro-icon-popover
        v-if="schema.attributesInfo"
        :class="[schema.attributesInfo.right ? 'ml-1 order-2' : 'mr-1']"
        :schema="schema"
        :model="model"
      />

      <v-text-field
        :rules="rules"
        :name="idDynamic"
        :id="generateId(idDynamic)"
        v-bind="schema.attributesTextField"
        :disabled="schema.readonly"
        v-model="value"
        :ref="schema.model"
        @blur="onBlur"
        @click:clear="clear"
        @change="onChange"
        @focus="onFocus"
        @input="onInput"
      >
        <template v-slot:label>
          {{ schema.attributesTextField.label }}
          <span v-if="schema.rules.includes('required')" class="red--text">*</span>
        </template>
      </v-text-field>
    </div>
  </div>
</template>

<script>
import { abstractField } from 'vue-form-generator';
import devComponentMixin from '@/mixins/dev-component-mixin';
import rulesMixin from '@/mixins/rules-mixin';
import inputEventsMixin from '@/mixins/input-events-mixin';
import componentMixin from '@/mixins/component-mixin';

export default {
  mixins: [abstractField, devComponentMixin, rulesMixin, inputEventsMixin, componentMixin],

  components: {
    i4proIconPopover: () => import('@/components/icons/i4pro-icon-popover')
  },

  methods: {
    async onBlur(event) {
      this.changeEvents(event);
    },

    clear() {
      this.$nextTick(() => (this.model[this.schema.model] = ''));
    }
  }
};
</script>
